import React from 'react'
import { ContentLayout } from 'components/Layouts'
import { useTranslation } from 'react-i18next'

import { useUserQuery } from 'queries/user'
import { AboveFold } from 'components/accountHome/AboveFold/AboveFold'
import { PersonalNav } from 'components/accountHome/PersonalNav/PersonalNav'
import { CurrentPlans } from 'components/accountHome/CurrentPlans/CurrentPlans'
import { Route } from 'react-router-dom'
import { AllOptionsModal } from 'components/accountHome/AllOptionsModal/AllOptionsModal'
import { CurrentDeductibles } from 'components/accountHome/CurrentDeductibles/CurrentDeductibles'
import { AdditionalResources } from 'components/accountHome/AdditionalResources/AdditionalResources'

export interface AccountHomeProps {}

export const AccountHome: React.FC<AccountHomeProps> = () => {
  const { t } = useTranslation('accountHome')
  const { data, isLoading } = useUserQuery()
  const user = data?.user

  const userFirstName = React.useMemo(() => user?.firstName, [user])
  const welcomeText = React.useMemo(
    () =>
      userFirstName && userFirstName !== ''
        ? t('headingWithName', { firstName: userFirstName })
        : t('headingWithoutName'),
    [userFirstName, t]
  )

  const isEMsnEnrolled = user?.eCorrespondenceSummary?.emsn_correspondence
  const isImmunosuppressiveDrugCoverage = user?.isImmunosuppressiveDrugCoverage
  const isMedicareAdvantage = user?.isMedicareAdvantage

  const hideDeductibles = user?.isMedicareAdvantage || !user?.hasPartB

  return (
    <>
      <ContentLayout heading={welcomeText} width="wide">
        <div className="ds-l-container my-u-pb--40">
          <AboveFold>
            <PersonalNav
              isLoading={isLoading}
              isEMsnEnrolled={Boolean(isEMsnEnrolled)}
              isImmunosuppressiveDrugCoverage={Boolean(
                isImmunosuppressiveDrugCoverage
              )}
              isMedicareAdvantage={Boolean(isMedicareAdvantage)}
            />

            <CurrentPlans />
          </AboveFold>

          {!hideDeductibles && <CurrentDeductibles />}

          <AdditionalResources />
        </div>
      </ContentLayout>
      <Route path="/home/allOptions">
        <AllOptionsModal eMsnEnrolled={isEMsnEnrolled} />
      </Route>
    </>
  )
}

export default AccountHome
